<template>
  <div>
    <b-card no-body>
      <div
        class="d-flex justify-content-md-between align-items-md-center flex-column-reverse flex-md-row card-padding"
      >
        <span class="header__label mt-1 mt-md-0"> Ticket Topic Data </span>
        <atom-button
          v-if="hasUpdatePermission"
          buttonId="create-new-ticket-topic"
          buttonStyle="border"
          class="d-flex justify-content-end"
          @click="showCreateNewTicketTicketTopicModal"
        >
          <template>Create New Topic</template>
        </atom-button>
      </div>

      <div class="row">
        <div class="col-12">
          <b-table
            sticky-header
            responsive
            :items="items"
            :fields="fields"
            :hover="hasUpdatePermission"
            @row-clicked="selectRow"
          >
            <template #cell(index)="data">
              <div class="header">{{ data.value }}</div>
            </template>
            <template #cell(topicName)="data">
              <div class="header">{{ data.value }}</div>
            </template>
            <template #cell(topicSubject)="data">
              <div class="header">{{ data.value }}</div>
            </template>
          </b-table>
        </div>
      </div>
    </b-card>
    <!-- ? Modal Create Ticket Topic -->
    <!-- start modal create -->
    <molecule-modal-dialog
      modalId="modal-create-new-ticket-topic"
      buttonTextLeft="Create"
      buttonColorLeft="primary"
      textTitle="New Ticket Topic"
      :isSlotBody="true"
      :isCloseOnBackDrop="false"
      :isDisableButtonLeft="isErrorAtNewTicketTopic"
      @clickButtonLeft="clickConfirmCreateTicketTopicFromModal"
      @clickButtonRight="clickCancelCreateTicketTopicFromModal"
      @clickIconClose="clickCancelCreateTicketTopicFromModal"
    >
      <template #body>
        <div class="w-100 d-flex justify-content-center row">
          <div class="new-ticket-topic-name-container w-80 mt-1">
            <atom-input
              v-model="newTicketTopic.topicName"
              title="Topic Name"
              placeholder="Topic Name"
              errorMessage="Please enter topic name"
              :isError="isErrorAtNewTicketTopicName"
              :isAsterisk="true"
            ></atom-input>
          </div>
          <div class="new-ticket-topic-subject-container w-80 mt-1">
            <atom-input
              v-model="newTicketTopic.topicSubject"
              title="Topic Subject"
              placeholder="Topic Subject"
              errorMessage="Please enter topic subject"
              :isError="isErrorAtNewTicketTopicSubject"
              :isAsterisk="true"
            ></atom-input>
          </div>
          <div class="new-ticket-topic-detail-container w-80 mt-1">
            <atom-text-area
              v-model="newTicketTopic.topicDetail"
              title="Topic Detail"
              placeholder="Topic Detail"
              errorMessage="Please enter topic detail"
              :isError="isErrorAtNewTicketTopicDetail"
              :isAsterisk="true"
              :isResizable="true"
            ></atom-text-area>
          </div>
        </div>
      </template>
    </molecule-modal-dialog>
    <!-- end modal create -->

    <!-- ? Modal Edit Ticket Topic -->
    <!-- start modal edit -->
    <molecule-modal-dialog
      modalId="modal-edit-ticket-topic"
      buttonTextLeft="Save Changes"
      buttonColorLeft="primary"
      textTitle="Edit Ticket Topic"
      :isSlotBody="true"
      :isCloseOnBackDrop="false"
      :isDisableButtonLeft="
        !isTargetTicketTopicChange || isErrorAtTargetTicketTopic
      "
      @clickButtonLeft="clickConfirmEditTicketTopicFromModal"
      @clickButtonRight="clickCancelEditTicketTopicFromModal"
      @clickIconClose="clickCancelEditTicketTopicFromModal"
    >
      <template #body>
        <div class="w-100 d-flex justify-content-center row">
          <div class="contract-period-name-container w-80 mt-1">
            <atom-input
              v-model="targetTicketTopic.topicName"
              title="Topic Name"
              placeholder="Topic Name"
              errorMessage="Please enter topic name"
              :isError="isErrorAtTargetTicketTopicName"
              :isAsterisk="true"
            ></atom-input>
          </div>
          <div class="target-ticket-topic-subject-container w-80 mt-1">
            <atom-input
              v-model="targetTicketTopic.topicSubject"
              title="Topic Subject"
              placeholder="Topic Subject"
              errorMessage="Please enter topic subject"
              :isError="isErrorAtTargetTicketTopicSubject"
              :isAsterisk="true"
            ></atom-input>
          </div>
          <div class="target-ticket-detail-container w-80 mt-1">
            <atom-text-area
              v-model="targetTicketTopic.topicDetail"
              title="Topic Detail"
              placeholder="Topic Detail"
              errorMessage="Please enter topic detail"
              :isError="isErrorAtTargetTicketTopicDetail"
              :isAsterisk="true"
            ></atom-text-area>
          </div>
        </div>
      </template>
    </molecule-modal-dialog>
    <!-- end modal edit -->
  </div>
</template>

<script>
const replacer = (key, value) =>
  value instanceof Object && !(value instanceof Array)
    ? Object.keys(value)
        .sort()
        .reduce((sorted, key) => {
          sorted[key] = value[key]
          return sorted
        }, {})
    : value

import { BCard, BTable } from "bootstrap-vue"

import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomTextArea from "@/components/atoms/AtomTextArea.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"

import mixinsValidator from "@/mixins/mixinsValidator"
import mixinsUser from "@/mixins/mixinsUser"
import { PermissionUser } from "@/constants/permission-user"

export default {
  name: "OrganismTicketTopicManagement",

  mixins: [mixinsValidator, mixinsUser],

  components: {
    AtomButton,
    AtomInput,
    AtomTextArea,
    BCard,
    BTable,
    MoleculeModalDialog,
  },

  props: {
    fields: {
      type: Array,
      required: false,
      default: () => [],
    },
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
  },

  emits: [
    "onSendRequestToCreateTicketTopic",
    "onSendRequestToUpdateTicketTopic",
  ],

  data() {
    return {
      modalId: null,
      isValidateNewTicketTopicTrigger: false,
      isValidateTargetTicketTopicTrigger: false,
      newTicketTopic: {
        topicName: "",
        topicSubject: "",
        topicDetail: "",
      },
      targetTicketTopic: {
        index: 0,
        topicId: "",
        topicName: "",
        topicSubject: "",
        topicDetail: "",
      },
      originTargetTicketTopic: {
        index: 0,
        topicId: "",
        topicName: "",
        topicSubject: "",
        topicDetail: "",
      },
    }
  },

  computed: {
    hasUpdatePermission() {
      return this.hasPermission(PermissionUser.SETTINGS_WRITE)
    },
    isErrorAtNewTicketTopicName() {
      return this.isValidateNewTicketTopicTrigger
        ? this.isEmptyString(this.newTicketTopic.topicName)
        : false
    },
    isErrorAtNewTicketTopicSubject() {
      return this.isValidateNewTicketTopicTrigger
        ? this.isEmptyString(this.newTicketTopic.topicSubject)
        : false
    },
    isErrorAtNewTicketTopicDetail() {
      return this.isValidateNewTicketTopicTrigger
        ? this.isEmptyString(this.newTicketTopic.topicDetail)
        : false
    },
    isErrorAtNewTicketTopic() {
      return (
        this.isErrorAtNewTicketTopicName ||
        this.isErrorAtNewTicketTopicSubject ||
        this.isErrorAtNewTicketTopicDetail
      )
    },
    isTargetTicketTopicChange() {
      let originData = JSON.stringify(this.originTargetTicketTopic, replacer)
      let currentData = JSON.stringify(this.targetTicketTopic, replacer)
      return originData !== currentData
    },
    isErrorAtTargetTicketTopicName() {
      return this.isValidateTargetTicketTopicTrigger
        ? this.isEmptyString(this.targetTicketTopic.topicName)
        : false
    },
    isErrorAtTargetTicketTopicSubject() {
      return this.isValidateTargetTicketTopicTrigger
        ? this.isEmptyString(this.targetTicketTopic.topicSubject)
        : false
    },
    isErrorAtTargetTicketTopicDetail() {
      return this.isValidateTargetTicketTopicTrigger
        ? this.isEmptyString(this.targetTicketTopic.topicDetail)
        : false
    },
    isErrorAtTargetTicketTopic() {
      return (
        this.isErrorAtTargetTicketTopicName ||
        this.isErrorAtTargetTicketTopicSubject ||
        this.isErrorAtTargetTicketTopicDetail
      )
    },
  },

  methods: {
    navigateTo(path) {
      this.$router.push(path)
    },

    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = ""
    },

    showCreateNewTicketTicketTopicModal() {
      this.modalId = "modal-create-new-ticket-topic"
      this.$bvModal.show(this.modalId)
    },

    clickConfirmCreateTicketTopicFromModal() {
      this.isValidateNewTicketTopicTrigger = true
      this.$nextTick(() => {
        if (!this.isErrorAtNewTicketTopic) {
          const newTicketTopic = {
            topicName: this.newTicketTopic.topicName,
            topicSubject: this.newTicketTopic.topicSubject,
            topicDetail: this.newTicketTopic.topicDetail,
          }
          this.isValidateNewTicketTopicTrigger = false
          this.$emit("onSendRequestToCreateTicketTopic", newTicketTopic)
          this.closeModal()
          this.setNewTicketTopicToDefaultValue()
        }
      })
    },

    clickCancelCreateTicketTopicFromModal() {
      this.isValidateNewTicketTopicTrigger = false
      this.closeModal()
      this.setNewTicketTopicToDefaultValue()
    },

    setNewTicketTopicToDefaultValue() {
      this.newTicketTopic = {
        topicName: "",
        topicSubject: "",
        topicDetail: "",
      }
    },

    selectRow(ticketTicketTopic) {
      if (!this.hasUpdatePermission) return

      this.originTargetTicketTopic = JSON.parse(
        JSON.stringify(ticketTicketTopic)
      )
      this.targetTicketTopic = JSON.parse(JSON.stringify(ticketTicketTopic))
      this.showEditTicketTicketTopicModal()
    },

    showEditTicketTicketTopicModal() {
      this.modalId = "modal-edit-ticket-topic"
      this.$bvModal.show(this.modalId)
    },

    clickConfirmEditTicketTopicFromModal() {
      this.isValidateTargetTicketTopicTrigger = true
      this.$nextTick(() => {
        if (!this.isErrorAtTargetTicketTopic) {
          const editedTicketTopic = {
            topicId: this.targetTicketTopic.topicId,
            topicName: this.targetTicketTopic.topicName,
            topicSubject: this.targetTicketTopic.topicSubject,
            topicDetail: this.targetTicketTopic.topicDetail,
          }
          this.isValidateTargetTicketTopicTrigger = false
          this.$emit("onSendRequestToUpdateTicketTopic", editedTicketTopic)
          this.closeModal()
          this.setTargetTemplateToDefaultValue()
        }
      })
    },

    clickCancelEditTicketTopicFromModal() {
      this.isValidateTargetTicketTopicTrigger = false
      this.closeModal()
      this.setTargetTemplateToDefaultValue()
    },

    setTargetTemplateToDefaultValue() {
      this.originTargetTicketTopic = {
        index: 0,
        topicId: "",
        topicName: "",
        topicSubject: "",
        topicDetail: "",
      }
      this.targetTicketTopic = {
        index: 0,
        topicId: "",
        topicName: "",
        topicSubject: "",
        topicDetail: "",
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.header__label {
  font-weight: 500;
  font-size: 18px;
  color: #5e5873;
}

.card-padding {
  padding: 1.5rem;
}
</style>
